import { useState, useEffect, useRef } from 'react';

function SearchAddress({ isOpen, onClose, onSelect }) {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const postcodeRef = useRef(null);

  // 다음 주소 API 스크립트 로드
  useEffect(() => {
    if (!isOpen) return;

    // 이미 스크립트가 로드되어 있으면
    if (window.daum?.Postcode) {
      setIsScriptLoaded(true);
      return;
    }

    // 스크립트가 이미 추가되어 있는지 확인
    const existingScript = document.querySelector('script[src*="postcode.v2.js"]');
    if (existingScript) {
      // 스크립트가 로드될 때까지 대기
      const checkScript = setInterval(() => {
        if (window.daum?.Postcode) {
          setIsScriptLoaded(true);
          clearInterval(checkScript);
        }
      }, 100);
      return () => clearInterval(checkScript);
    }

    // 스크립트 추가
    const script = document.createElement('script');
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.async = true;
    script.onload = () => {
      setIsScriptLoaded(true);
    };
    script.onerror = () => {
      console.error('주소 검색 스크립트 로드 실패');
    };
    document.head.appendChild(script);
  }, [isOpen]);

  // 주소 검색 팝업 열기
  useEffect(() => {
    if (!isOpen) return;

    const openPostcode = () => {
      if (!window.daum?.Postcode) {
        console.error('다음 주소 API가 로드되지 않았습니다.');
        return;
      }

      try {
        postcodeRef.current = new window.daum.Postcode({
          oncomplete: (data) => {
            // 주소 선택 완료
            let fullAddress = data.address; // 기본 주소
            let extraAddress = ''; // 참고항목

            // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
            if (data.userSelectedType === 'R') {
              // 사용자가 도로명 주소를 선택했을 경우
              fullAddress = data.roadAddress;
            } else {
              // 사용자가 지번 주소를 선택했을 경우(J)
              fullAddress = data.jibunAddress;
            }

            // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
            if (data.userSelectedType === 'R') {
              // 법정동명이 있을 경우 추가한다. (법정리는 제외)
              // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
              if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                extraAddress += data.bname;
              }
              // 건물명이 있고, 공동주택일 경우 추가한다.
              if (data.buildingName !== '' && data.apartment === 'Y') {
                extraAddress += (extraAddress !== '' ? ', ' + data.buildingName : data.buildingName);
              }
              // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
              if (extraAddress !== '') {
                extraAddress = ' (' + extraAddress + ')';
              }
            }

            const completeAddress = fullAddress + extraAddress;
            onSelect?.(completeAddress);
            onClose();
          },
          onresize: (size) => {
            // 팝업 크기 조정
          },
          onclose: (state) => {
            // 팝업이 닫힐 때
            if (state === 'FORCE_CLOSE') {
              onClose();
            }
          },
          width: '100%',
          height: '100%',
          maxSuggestItems: 5
        });
        
        postcodeRef.current.open();
      } catch (error) {
        console.error('주소 검색 팝업 열기 실패:', error);
      }
    };

    if (isScriptLoaded) {
      // 스크립트가 로드되면 바로 열기
      openPostcode();
    } else {
      // 스크립트 로드 대기
      const checkInterval = setInterval(() => {
        if (window.daum?.Postcode) {
          setIsScriptLoaded(true);
          clearInterval(checkInterval);
        }
      }, 100);

      return () => clearInterval(checkInterval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, isScriptLoaded]); // onClose와 onSelect는 props로 안정적이므로 dependency에서 제외

  // 팝업은 다음 주소 API의 open() 메서드가 자동으로 처리하므로
  // 이 컴포넌트는 스크립트 로드와 팝업 열기만 담당
  return null;
}

export default SearchAddress;

